var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.805 16.598c.205.41.067.902-.305 1.15l-.098.057-10 5c-.217.109-.467.124-.693.047l-.111-.047-10-5c-.445-.222-.625-.763-.403-1.207.205-.41.682-.596 1.103-.447l.104.044 9.598 4.8 9.598-4.8c.444-.222.985-.042 1.207.403zm0-5c.205.41.067.902-.305 1.15l-.098.057-10 5c-.217.109-.467.124-.693.047l-.111-.047-10-5c-.445-.222-.625-.763-.403-1.207.205-.41.682-.596 1.103-.447l.104.044 9.598 4.8 9.598-4.8c.444-.222.985-.042 1.207.403zM11.598 1.195c.253-.127.551-.127.804 0l10 5c.664.332.664 1.278 0 1.61l-10 5c-.253.127-.551.127-.804 0l-10-5c-.664-.332-.664-1.278 0-1.61l10-5zM12 3.005L4.011 7 12 10.994 19.988 7 12 3.005z",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarManage);
export default __webpack_public_path__ + "static/media/navbar-manage.4f6d46f401b70b7681c17578d1dff5fc.svg";
export { ForwardRef as ReactComponent };